import React from 'react'

function WebQuiz() {
  return (
    <div>
      
    </div>
  )
}

export default WebQuiz
